import React from "react";
import { LegalLayout, Section, CONTACT_EMAIL } from "../components/Legal";

const UL = ({ children }) => <ul className="list-disc pl-5 space-y-1">{children}</ul>;

export default function PrivacyPolicy() {
  return (
    <LegalLayout title="Gizlilik Politikası" updated="18 Ekim 2026" testId="privacy-page">
      <p>
        Bu metin, YZ Matematik'i (yzmatematik.com) kullanırken hangi bilgilerin işlendiğini, bu bilgilerin
        ne amaçla kullanıldığını ve nasıl korunduğunu açıklar. YZ Matematik, LGS ve YKS (TYT/AYT) matematik
        hazırlığı için yapay zekâ destekli bir öğrenme platformudur.
      </p>

      <Section title="1. İşlenen bilgiler">
        <p><strong>Hesap bilgileri:</strong></p>
        <UL>
          <li>E-posta ve şifre ile kayıt olursanız: adınız, e-posta adresiniz ve şifrenizin geri döndürülemez biçimde şifrelenmiş (bcrypt) hâli. Şifrenizin kendisi saklanmaz.</li>
          <li>Google ile giriş yaparsanız: Google hesabınızdaki adınız, e-posta adresiniz, profil fotoğrafınızın adresi ve Google hesap kimliğiniz.</li>
          <li>Hesap türünüz (öğrenci, öğretmen veya yönetici) ve kayıt tarihiniz.</li>
        </UL>
        <p><strong>Öğrenme verileri:</strong> çözdüğünüz sorular, verdiğiniz cevaplar (doğru, yanlış veya boş), cevap zamanları, çalışma oturumlarınız, konu bazlı başarı ve ilerleme bilgileriniz ile size gösterilen çalışma önerileri.</p>
        <p><strong>Öğretmen başvurusu (yalnızca başvurursanız):</strong> ad soyad, telefon numarası, kısa açıklama ve aydınlatma metnine verdiğiniz onay.</p>
        <p><strong>Sınıf üyeliği (yalnızca bir sınıfa katılırsanız):</strong> katıldığınız sınıf ve katılım tarihiniz.</p>
        <p><strong>Teknik veriler:</strong> oturum çerezi, giriş sırasında kullanılan kısa ömürlü güvenlik çerezi ve aşağıda açıklanan kullanım analitiği verileri.</p>
      </Section>

      <Section title="2. Google ile giriş">
        <p>
          Google ile giriş yaptığınızda Google'dan yalnızca temel profil bilgilerinizi (<em>openid</em>,
          <em> email</em>, <em>profile</em> izinleri) isteriz: adınız, e-posta adresiniz, e-posta adresinizin
          doğrulanmış olup olmadığı, profil fotoğrafınızın adresi ve Google hesap kimliğiniz. Bu bilgiler
          yalnızca hesabınızı oluşturmak, sizi tanımak ve oturumunuzu açmak için kullanılır.
        </p>
        <p>
          Google hesabınızdaki e-postalara, dosyalara, kişilere veya başka verilere erişmeyiz. Google'dan
          aldığımız erişim belgelerini saklamayız ve bu bilgileri reklam amacıyla kullanmayız. Google
          bilgilerinin kullanımı, Google API Hizmetleri Kullanıcı Verileri Politikası'na (Sınırlı Kullanım
          şartları dahil) uygundur.
        </p>
      </Section>

      <Section title="3. Bilgilerin kullanım amaçları">
        <UL>
          <li>Hesabınızı oluşturmak, giriş yapmanızı ve oturumunuzu sürdürmenizi sağlamak.</li>
          <li>Size uygun soruları seçmek, ilerlemenizi göstermek ve kişiselleştirilmiş çalışma önerileri sunmak.</li>
          <li>Konu ve alt konu performansınızı değerlendirmek, eksik öğrenme alanlarınızı belirlemek ve size gelişim raporunuzu göstermek.</li>
          <li>Öğretmen başvurularını değerlendirmek.</li>
          <li>Bir sınıfa katıldıysanız, sınıf öğretmeninize sınıfa katıldıktan sonraki gelişiminizi göstermek.</li>
          <li>Hizmetin güvenliğini, performansını ve çalışmasını sürdürmek; uygulama kullanımını analitik aracıyla değerlendirmek.</li>
        </UL>
      </Section>

      <Section title="4. Bilgilerin kimlerle paylaşıldığı">
        <UL>
          <li><strong>Öğretmeniniz:</strong> Katılım koduyla bir sınıfa katılırsanız, o sınıfın öğretmeni adınızı, e-posta adresinizi, katılım tarihinizi ve sınıfa katıldıktan sonraki soru çözme verilerinizi görebilir: soru sayısı, doğru/yanlış/boş sayıları, başarı oranı, konu ve alt konu bazında başarınız, yanlış cevap verdiğiniz soruların kodları ve haftalık gelişiminiz. Sınıfa katılmadan önceki çözümleriniz öğretmeninize gösterilmez. Sınıftan istediğiniz zaman ayrılabilirsiniz.</li>
          <li><strong>Yönetici:</strong> Öğretmen başvurusundaki telefon numarası yalnızca site yöneticisi tarafından görülür; öğrenci ekranlarında veya herkese açık bir yerde gösterilmez.</li>
          <li><strong>Yapay zekâ hizmetleri:</strong> Çalışma önerilerinin açıklaması gibi bazı içerikler, bir yapay zekâ hizmet sağlayıcısının (OpenAI) modelleriyle üretilebilir. Bu isteklere konu adı ve başarı yüzdesi gibi özet istatistikler eklenir; adınız ve e-posta adresiniz gönderilmez.</li>
          <li><strong>Altyapı hizmetleri:</strong> Uygulama ve veritabanı bir bulut barındırma hizmet sağlayıcısında barındırılır; soru görselleri aynı sağlayıcının dosya depolama hizmetinde saklanır. Google ile giriş, Google'ın kimlik doğrulama hizmetiyle yapılır.</li>
        </UL>
        <p>Bilgilerinizi satmayız ve reklam amacıyla paylaşmayız.</p>
      </Section>

      <Section title="5. Çerezler ve kullanım analitiği">
        <UL>
          <li><strong>Oturum çerezi</strong> (<code>session_token</code>): Giriş yaptığınızı hatırlamak için kullanılır. JavaScript ile okunamaz ve en fazla 7 gün geçerlidir. Çıkış yaptığınızda silinir.</li>
          <li><strong>Google giriş güvenlik çerezi</strong> (<code>g_oauth_state</code>): Yalnızca Google ile giriş sırasında, isteğin sizden geldiğini doğrulamak için kullanılır ve en fazla 10 dakika geçerlidir.</li>
          <li><strong>Kullanım analitiği:</strong> Sitede PostHog analitik aracı çalışır. Bu araç sayfa görüntüleme ve etkileşim bilgilerini toplayabilir ve oturum kaydı özelliği açıktır, yani sayfadaki etkileşimlerinizi kaydedebilir.</li>
        </UL>
      </Section>

      <Section title="6. Saklama süresi ve silme">
        <p>
          Hesap ve öğrenme verileriniz, hesabınız var olduğu sürece saklanır; şu anda otomatik bir silme
          süresi uygulanmamaktadır. Oturum kayıtlarının geçerliliği 7 gün sonra sona erer.
        </p>
        <p>
          Hesabınızın ve ilgili verilerinizin silinmesini <a className="text-[#007BFF] hover:underline" href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a> adresine
          yazarak isteyebilirsiniz. Uygulamada henüz kendi kendine hesap silme özelliği bulunmadığı için
          silme işlemi bu e-posta üzerinden elle yapılır.
        </p>
      </Section>

      <Section title="7. Güvenlik">
        <p>
          Bağlantılar HTTPS ile şifrelenir. Şifreler bcrypt ile şifrelenerek saklanır. Oturum çerezi
          JavaScript'ten erişilemeyecek ve yalnızca güvenli bağlantı üzerinden gönderilecek şekilde ayarlanır.
          Yönetici ve öğretmen işlemleri sunucu tarafında yetki kontrolünden geçer. Hiçbir sistem tamamen
          risksiz değildir; ancak bilgilerinizi korumak için makul önlemler alırız.
        </p>
      </Section>

      <Section title="8. Haklarınız">
        <p>
          6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) kapsamında; verilerinizin işlenip
          işlenmediğini öğrenme, bilgi talep etme, düzeltilmesini veya silinmesini isteme gibi haklara
          sahipsiniz. Taleplerinizi aşağıdaki iletişim adresine iletebilirsiniz.
        </p>
      </Section>

      <Section title="9. Değişiklikler">
        <p>Bu politika güncellenebilir. Güncel sürüm her zaman bu sayfada yayımlanır ve üstteki tarih değiştirilir.</p>
      </Section>

      <Section title="10. İletişim">
        <p>
          Gizlilikle ilgili sorularınız için: <a className="text-[#007BFF] hover:underline" href={`mailto:${CONTACT_EMAIL}`} data-testid="privacy-contact-email">{CONTACT_EMAIL}</a>
        </p>
      </Section>
    </LegalLayout>
  );
}
